<template>
    <v-container>
        <v-row>
            <v-col>
                <h4 class="text-h4">Landed Cost</h4>
                <p class="text-subtitle-1">New Landed Cost</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <LandedCostForm ref="form" v-model="data"/>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block color="primary" :loading="loading" @click="handleSave">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="handleCancel">
                    cancel
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.display"/>
    </v-container>
</template>

<script>
import LandedCostForm from '../../components/purchase/LandedCostForm.vue';
import { v4 as uuid } from 'uuid';
import PAlert from '../../components/common/PAlert.vue';
import landedCost from '../../services/purchase/landedCost';
export default {
    components: {
        LandedCostForm,
        PAlert
    },
    data() {
        return {
            loading: false,
            data: {},
            alert: {
                display: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            idempotentKey: null
        }
    },
    methods: {
        handleSave() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to save?", callback: this.save };
        },
        save() {
            if(!this.$refs.form.$refs.form.validate()) return;
            this.loading = true;
            let data = {
                ...this.data,
                lines: this.data.items,
                component_lines: this.data.components
            }
            landedCost.store({...data, idempotentKey: this.idempotentKey}).then(res => {
                this.$router.replace({
                    name: "LandedCostDisplay",
                    params: {
                        id: res.data.id
                    }
                })
            }).finally(() => {
                this.loading = false;
            })
        },
        handleCancel() {
            this.alert = { ...this.alert, display: true, content: "Are you sure you want to discard changes?", callback: this.cancel };
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>